import { Component, OnInit } from "@angular/core";

@Component({
  templateUrl: "narik-nb-message-dialog.component.html",
  styleUrls:["narik-nb-message-dialog.component.css"]
})
export class NarikNebularMessageDialog implements OnInit {
  message: string;
  constructor() {}

  ngOnInit() {}
}
